<template>
  <div>
    <wc-data-box hideToolbar>
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='labelClass'>Subtotal</td>
            <td class='text-right'>{{ subtotal | dec }}</td>
          </tr>
          <tr>
            <td :class='labelClass'>Tax</td>
            <td class='text-right'>{{ tax | dec }}</td>
          </tr>
          <tr class='grey lighten-4'>
            <td :class='labelClass'>Total</td>
            <td class='text-right font-weight-bold'>{{ total | decMoney }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>

export default {
  name: 'invoice-totals',
  props: {
    invoice: {
      required: true
    },
    lines: {
      required: true
    }
  },
  data: () => ({
    labelClass: 'grey--text overline',
    isLoading: false,
  }),
  computed: {
    tax() {
      let tax = 0;
      for (const [index, line] of this.lines.entries()) {
        console.log(index);
        if (line.has_gst && !line.is_warranty) {
          tax += Math.round((line.qty * line.price) * this.$store.state.misc.settings.tax_rate_perc * 100) / 100;
        }
      }
      return tax;
    },
    subtotal() {
      let subtotal = 0;

      for (let i = 0; i < this.lines.length; i++) {
        if (!this.lines[i].is_warranty) {
          subtotal += (this.lines[i].qty * this.lines[i].price)
        }
      }
      return subtotal
    },
    total() {
      return this.tax + this.subtotal;
    }
  }
}
</script>
